<template>
  <div>
    <v-card
      class="mx-auto mb-3 card-box avatar-list"
      :class="cardClass"
      elevation="0"
      @click="goPage()"
    >
      <v-card-title class="pa-0">
        <v-avatar size="38" :color="iconAvatarColor" class="mr-4">
          <icon-application
            v-if="gubun === 'applDoc'"
            :width="18"
            :height="18"
          />
          <icon-work-status
            v-if="gubun === 'workstatus'"
            :width="18"
            :height="18"
          />
          <icon-pay v-if="gubun === 'pay'" :width="18" :height="18" />
          <icon-my-folder
            v-else-if="gubun === 'mybox'"
            :width="18"
            :height="18"
          />
          <icon-monitor v-else-if="gubun === 'org'" :width="18" :height="18" />
          <icon-birth
            v-else-if="gubun === 'maternity'"
            :width="18"
            :height="18"
          />
          <icon-overtime
            v-else-if="gubun === 'overtimeApp'"
            :width="18"
            :height="18"
          />
          <icon-paid-holiday
            v-else-if="gubun === 'vacationMyWorkHolidayMain'"
            :width="18"
            :height="18"
          />
        </v-avatar>
        {{ btnName }} <span class="num">{{ numName }}</span>
        <v-icon v-show="pageIconShow" color="#505961" class="ml-auto pa-0">
          mdi-chevron-right
        </v-icon>
      </v-card-title>
    </v-card>
  </div>
</template>

<script>
/* 버튼위젯 컴포넌트 */
import IconPay from '@/assets/customIcon/IconPay.vue';
import IconMyFolder from '@/assets/customIcon/IconMyFolder.vue';
import IconApplication from '@/assets/customIcon/IconApplication.vue';
import IconMonitor from '@/assets/customIcon/IconMonitor.vue';
import IconBirth from '@/assets/customIcon/IconBirth.vue';
import IconOvertime from '@/assets/customIcon/IconOvertime.vue';
//import IconApprovalDoc from '@/assets/customIcon/IconApprovalDoc.vue';
import IconWorkStatus from '@/assets/customIcon/IconWorkStatus.vue';
import IconPaidHoliday from '@/assets/customIcon/IconPaidHoliday.vue';
import routerNames from '@/const/routerConstants';
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import { getApprDocList } from '@/api/allDoc.js';

export default {
  props: {
    // pay:급여명세서, mybox:내문서함, org:부서원근태현황, maternity:출산휴가
    gubun: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    btnName: '', // 버튼명
    pageName: '', // 페이지명 (연결화면)
    cardClass: '', // v-card class (작은버튼-'card-block' 추가필!)
    iconAvatarColor: '#f4f6f7', // 아이콘배경 컬러코드
    pageIconShow: true, // 페이지아이콘플래그 (작은버튼-false 변경필!)
    applParam: {}, // 신청서연결용 파라미터
    numName: '',
  }),
  methods: {
    /* 데이터초기화 */
    async initData() {
      // console.log('this gubun :' + this.gubun);

      switch (this.gubun) {
        case 'applDoc':
        // eslint-disable-next-line no-case-declarations
        const paramObj = {
          searchDate: dayjs().format('YYYY'),
          multiSearchApplCd: '', //"'22','23','30','42','43','110','301'", // 조회신청서코드(근무,근태관련)
        };
        // eslint-disable-next-line no-case-declarations
        const response = await getApprDocList(paramObj);
        // eslint-disable-next-line no-case-declarations
        const dataList = response.data.data;

          this.btnName = '결재대기';
          this.numName = dataList.length;
          this.pageName = routerNames.ApprDoc;
          this.cardClass = 'paybox';
          this.iconAvatarColor = '#ffffff';
          break;
        
        case 'mybox':
          this.btnName = '최근신청내역(1개월)';
          this.numName = '';
          this.pageName = routerNames.MyBox;
          this.cardClass = 'mybox';
          this.iconAvatarColor = '#ffffff';
          break;

        case 'org':
          this.btnName = '부서 근태/휴가 현황';
          this.numName = '';
          this.pageName = routerNames.OrgGntWorkSta;
          this.cardClass = 'orgGntWorkSta';
          this.iconAvatarColor = '#ffffff';
          break;

        case 'vacationMyWorkHolidayMain':
          this.btnName = '근태/휴가 신청';
          this.numName = '';
          this.pageName = routerNames.VacationMyWorkHolidayMain;
          this.cardClass = 'annualHolidaySta';
          this.iconAvatarColor = '#ffffff';
          break;

        case 'pay':
          this.btnName = '급여명세서';
          this.numName = '';
          this.pageName = routerNames.SelectPayGubun;
          this.cardClass = 'salary';
          this.iconAvatarColor = '#ffffff';
          break;

        case 'workstatus':
          this.btnName = '근무현황';
          this.numName = '';
          this.pageName = routerNames.SelectPayGubun;
          this.cardClass = 'workstatus';
          this.iconAvatarColor = '#ffffff';
          break;

        case 'overtimeApp':
          this.btnName = '연장근무신청';
          this.numName = '';
          this.pageName = routerNames.Application;
          this.cardClass = 'overtimeApp';
          this.applParam = { applCd: '110' };
          this.iconAvatarColor = '#ffffff';
          break;

        case 'maternity':
          this.numName = '';
          this.btnName = '배우자 출산휴가';
          this.pageName = routerNames.MaternityHolidaySta;
          this.cardClass = 'maternity';
          this.iconAvatarColor = '#fff4f6';
          break;
      }
    },
    /* 페이지이동 */
    goPage() {
      if (this.pageName === routerNames.Application) {
        this.toApplicationPage();
      } else {
        this.$router.push({ name: this.pageName });
      }
    },

    /* 신청서화면 이동시 */
    async toApplicationPage() {
      let name = await this.$store.dispatch(
        'ELA/FETCH_MENU_ACTION',
        this.applParam,
      );
      this.$router.push({ name });
    },
  },
  created() {
    this.initData();
  },
  mounted() {},
  computed: {
    ...mapGetters('MENU', ['GET_APPR_DOC_CNT']),
  },
  components: {
    IconPay,
    IconMyFolder,
    IconMonitor,
    IconBirth,
    IconOvertime,
    //IconApprovalDoc,
    IconWorkStatus,
    IconPaidHoliday,
    IconApplication,
  },
};
</script>
